import { render } from "./ChatBalloon.vue?vue&type=template&id=862b3092&scoped=true"
import script from "./ChatBalloon.vue?vue&type=script&lang=js"
export * from "./ChatBalloon.vue?vue&type=script&lang=js"

import "./ChatBalloon.vue?vue&type=style&index=0&id=862b3092&scoped=true&lang=css"

import exportComponent from "/Users/vincent/Documents/GIT_CLONES/skipiste/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-862b3092"]])

export default __exports__